/* template */
<template minapp="mpx" xlang="wxml"><div class="contact-phone-wrap"><from-item :isShow="(isShow)" :isRequired="(isRequired)" :isRequiredShow="(isRequiredShow)" label="手机号码" :innerValue="(innerValue)" :nameTips="(nameTips)"><template slot="input"><es-field placeholder="请输入手机号码" :value="innerValue" mpxModelEvent="input" @mpxModel='__model("innerValue", $event, ["value"], undefined)' @focus="phoneFocus" @blur="onBlur"/></template></from-item><mpx-view @tap="triggerPopup" class="label-area"><div class="label-area-text">{{currentArea.pre}}</div><mpx-image :src="(arrowRight)" class="label-area-icon" v-if="(!isLabelAreaDefault)"/></mpx-view><es-popup position="bottom" :show="(showPopup)"><div class="container"><div class="area"><mpx-view v-for="(item, index) in (phoneArea)" @tap="chooseArea(item)" class="item text">{{item.name}}</mpx-view></div><mpx-view @tap="triggerPopup" class="close text">取消</mpx-view></div></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m23c45705"}'>
  .contact-phone-wrap
    position relative
  .label-area
    position absolute
    top 40px
    display flex
    align-items center
    &-text
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 17px
      color #999999
    &-icon 
      width 5.3px
      height 8px
      margin-left 5.3px
  .container
    background #F6F7F8
    border-radius 10px 10px 0 0 
    .area
      .item
        display flex
        justify-content center
        align-items center
        height 48px
        background #FFFFFF
        border-bottom rgba(0, 0, 0, 0.06);
        &:first-child
          border-radius 10px 10px 0 0 
    .close
      display flex
      justify-content center
      align-items center
      height 48px
      background #FFFFFF
      margin-top 8px
    .text
      font-family PingFangSC-Regular;
      font-size 16px
      font-weight normal
      line-height 19px
      text-align center
      letter-spacing 0px
      color rgba(0, 0, 0, 0.84)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m23c45705"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./contact-phone12306.mpx.js?isComponent&outputPath=components%2Fcontact-phone1230623c45705%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./contact-phone12306.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcontact-phone1230623c45705%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m23c45705"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/contact-phone1230623c45705/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-popup':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
